import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useOffer from "../../api/hooks/useOffers";
import { logMsgBgColors } from "../../consts/misc";
import { toIcons } from "../../consts/Paths";
import MainContext from "../../context/MainContext";
import useIsMobile from "../../hooks/useIsMobile";
import useLogMessage from "../../hooks/useLogMessage";
import useToggle from "../../hooks/useToggle";
import { Offer } from "../../interfaces";
import "../../styles/Modals.css";
import { getAvailableProposal } from "../../utils/getMethods";
import { offerRemappingFromResult } from "../../utils/offerRemapping";
import LogMessage from "../misc/LogMessage";

const ProposalModal = (props: any) => {
  const { isMobile } = useIsMobile();
  const addToProposalForm = useForm();
  const logMessage = useLogMessage();

  const { token, offer, setOffer, refresh } = useContext(MainContext);
  const { RESPONSES, RESULTS, CTAs } = useOffer();

  const [openOffers, setOpenOffers] = useState<Offer[]>([]);
  const [offersFetched, setOffersFetched] = useState<Offer[]>([]);

  const tempLoading = useToggle(false);

  useEffect(() => {
    if (tempLoading.isToggled) {
      /* caricamento */
      logMessage.setMessageTimer(20000);
      logMessage.write("subject", "Loading . . .");
      logMessage.write("bgColor", logMsgBgColors.loading);
    } else if (!tempLoading.isToggled) {
      logMessage.setMessageTimer(null);
    }
  }, [tempLoading.isToggled]);

  useEffect(() => {
    tempLoading.setIsToggled(true);
    CTAs.getOffersListAll();
  }, []);

  useEffect(() => {
    if (offersFetched) {
      const tempOpenOffers = getAvailableProposal(offersFetched);
      setOpenOffers(tempOpenOffers);
    }
  }, [offersFetched]);

  useEffect(() => {
    /*  console.log(
      RESPONSES.getOffersListAllResponse,
      RESULTS.getOffersListAllResult
    ); */
    if (RESPONSES.getOffersListAllResponse?.ok) {
      tempLoading.setIsToggled(false);
      setOffersFetched(RESULTS.getOffersListAllResult.offerts);
    }
    if (RESPONSES.getOffersListAllResponse?.ok === false) {
      tempLoading.setIsToggled(false);
    }
  }, [RESPONSES.getOffersListAllResponse]);

  const onSubmit = (data: any) => {
    tempLoading.setIsToggled(true);
    /* console.log(data, props.model.id, "add to proposal"); */
    const match = offersFetched.find(
      (el) => el.id === Number.parseInt(data.offer_id)
    );
    const proposedList = match?.models_proposed_list;
    const finalList: number[] = [];
    proposedList?.forEach((element) => finalList.push(element.model_id));
    if (finalList?.includes(props.model.id)) {
    } else {
      finalList.push(props.model.id);
    }
    /* console.log(finalList); */
    CTAs.updateOffer(data.offer_id, {
      ...match,
      models_proposed_list: finalList,
    });
  };

  useEffect(() => {
    /* console.log(RESPONSES.updateResponse, RESULTS.updateResult); */
    if (RESPONSES.updateResponse?.ok) {
      tempLoading.setIsToggled(false);
      logMessage.write(
        "subject",
        `${props.model.bio.name} ${props.model.bio.surname}`
      );
      logMessage.write("other_text", " has been added successfully!");
      logMessage.write("bgColor", logMsgBgColors.correct);
      const tOffer = offerRemappingFromResult(RESULTS.updateResult.data);
      setOffer(tOffer);
      setTimeout(() => {
        props.togglerProposalModal.toggle();
      }, 3000);
    } else if (RESPONSES.updateResponse?.ok === false) {
      tempLoading.setIsToggled(false);
      logMessage.write(
        "subject",
        `${props.model.bio.name} ${props.model.bio.surname}`
      );
      logMessage.write("other_text", " could not be added to the offer");
      logMessage.write("bgColor", logMsgBgColors.error);
    }
  }, [RESPONSES.updateResponse]);

  const renderOptions = openOffers.map((item: Offer, key: number) => {
    return (
      <option key={key} value={item.id}>
        {item.offer_name}
      </option>
    );
  });

  return (
    <div
      className="modal-wrapper"
      style={{
        height: `100vh`,
      }}
    >
      <div
        id="#proposal_modal"
        className={`proposal-modal  ${
          isMobile && "general-modal-dimension-Mob"
        }`}
        style={{
          width: isMobile ? "calc(345px - 64px)" : "" /* 
          height: "75vh", */,
          padding: isMobile ? "25px 19px 0 21px" : "",
        }}
      >
        <form onSubmit={addToProposalForm.handleSubmit(onSubmit)}>
          <div className="proposal-modal-content">
            <div className="modal-header">
              <p className="modal-title">Add to proposal</p>
              <div className="Oval" onClick={props.togglerProposalModal.toggle}>
                <img src={`${toIcons}/close.svg`} />
              </div>
            </div>
            <div
              className="customInputText-box"
              style={{ width: `100%`, marginTop: isMobile ? "25px" : "55px" }}
            >
              <p className="customInputText-title">Offer's name</p>
              <select
                className={`customInputText-input`}
                style={{ width: " 100% " }}
                {...addToProposalForm.register("offer_id", {
                  required: true,
                })}
              >
                <option></option>
                {renderOptions}
              </select>
            </div>
            <button
              className="button2 proposal-modal-button-addon"
              type="submit"
              style={{
                marginTop: isMobile ? "85px" : "53px",
                width: isMobile ? "100%" : "",
              }}
            >
              <p className="button2-text">Save</p>
            </button>
          </div>
        </form>
      </div>
      {logMessage.isToggled && (
        <LogMessage
          text={{
            subject: logMessage.message.subject,
            other_text: logMessage.message.other_text,
            complement: logMessage.message.complement,
          }}
          bgColor={logMessage.message.bgColor}
        />
      )}
    </div>
  );
};
export default ProposalModal;
